import { FabricImage } from "fabric";
import { useEffect } from "react";
import { CanvasElementProps } from "./Canvas";

type Props = {
  objectUrl: undefined | string;
  // pass canvasWidth so background image can scale itself by width
  canvasWidth: number;
  // still need to know the imageHeight & imageWidth or xRatio & yRatio for calculating Span locations
  getRealImageSizes: (data: {
    imgWidth: number;
    imgHeight: number;
    realImgWidth: number;
    realImgHeight: number;
  }) => void;
} & CanvasElementProps;

const BackgroundImage = (props: Props) => {
  if (props.canvas == null) {
    throw new Error("Canvas Elements must the canvas prop passed");
  }

  if (!props.objectUrl) {
    props.canvas.backgroundImage = undefined;
    props.canvas.renderAll();
    return null;
  }

  useEffect(() => {
    if (!props.objectUrl) {
      props.canvas!.backgroundImage = undefined;
      props.canvas!.renderAll();
    }

    const fabricImg = FabricImage.fromURL(props.objectUrl!, undefined, {
      top: 0,
      left: 0,
      canvas: props.canvas!,
    }).then((img) => {
      img.scaleToWidth(props.canvasWidth);
      props.canvas!.backgroundImage = img;

      props.getRealImageSizes({
        imgWidth: img.getScaledWidth(),
        imgHeight: img.getScaledHeight(),
        realImgHeight: img.height!,
        realImgWidth: img.width!,
      });
      props.canvas?.renderAll();
    });
  }, [props.objectUrl, props.canvasWidth]);

  return null;
};

export { BackgroundImage };
